import { render } from "./AddressFields.vue?vue&type=template&id=03b49907&ts=true"
import script from "./AddressFields.vue?vue&type=script&lang=ts"
export * from "./AddressFields.vue?vue&type=script&lang=ts"

import exportComponent from "/home/helder/SDD_2/Projetos/goldylocks-central-ui-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__